import Vue from 'vue'
import VueRouter from 'vue-router'
import Loading from '../components/loading.vue';
Vue.use(VueRouter)


const routes = [
  // {path: '/',name: 'FloorPlans',component: () => import('../views/FloorPlans.vue')},

  {path:"/",name: "Project Information",component: () => import('../views/Information.vue')},
  {path:"/Model",name: "Real Time Rotating Model",component: () => import('../views/Model.vue')},
  {path:"/Gallery",name: "Gallery",component: () => import('../views/Gallery.vue')},
  {path: "/Brochure",name: "Brochure",component: () => import('../views/Brochure.vue')},
  {path:"/Location",name: "Location",component: () => import('../views/Location.vue')},
  {path:"/Pano",name: "PANO VIEW",component: () => import('../views/pano.vue')},
  {path:"/Facilities",name: "Facilities",component: () => import('../views/Facilities.vue')},
  {path:"/FloorPlans",name: "Floor Plans",component: () => import('../views/FloorPlans.vue')},
  {path:"/Developer",name: "Developer",component: () => import('../views/Developer.vue')},
  {path:"/Media",name: "Media",component: () => import('../views/Media.vue')},
  {path:"/Unit",name: "Unit",component: () => import('../views/Unit.vue')},
  {path:"/UnitCompare",name: "UnitCompare",component: () => import('../views/UnitCompare.vue')},
  
]



const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// // 添加全局导航守卫
// router.beforeEach((to, from, next) => {
//   // 开始加载动画
//   document.body.classList.add('loading');

//   // setTimeout(() => {
//   //   // 模拟加载时间
//   //   next();
//   // }, 5000);
  
// });

// router.afterEach(() => {
//   // 结束加载动画
//   document.body.classList.remove('loading');
// });


export default router
